var _path, _line, _path2, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFuelPump(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 216,
    x2: 192,
    y2: 216,
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168,112h24a16,16,0,0,1,16,16v38a18,18,0,0,0,18,18h0a18,18,0,0,0,18-18V86.63a16,16,0,0,0-4.69-11.32L220,56",
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: 112,
    x2: 96,
    y2: 112,
    fill: "none",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelPump);
export default __webpack_public_path__ + "static/media/fuelPump.ea0d423566cff37cfc6a6cc39c3fd0f4.svg";
export { ForwardRef as ReactComponent };